import React, {useEffect, useRef, useContext} from 'react';
import {CircularProgress} from '@material-ui/core';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {useTranslation} from 'react-i18next';

import Context from 'utils/Context';

import StripeCheckoutForm from './StripeCheckoutForm';
// import './PaiementStripe.scss';

const Stripe = ({paymentIntent, onClose}) => {
  const {appState} = useContext(Context);

  const {i18n} = useTranslation();

  const stripePromise = useRef(null);

  const email = appState.user.email;

  useEffect(() => {
    if (!appState.conf.STRIPE_API_PK) return;
    stripePromise.current = loadStripe(appState.conf.STRIPE_API_PK);

    return () => {
      stripePromise.current = null;
    };
  }, [appState.conf.STRIPE_API_PK]);

  if (!stripePromise.current)
    return (
      <div>
        <CircularProgress />
      </div>
    );

  return (
    <Elements stripe={stripePromise.current} options={{locale: i18n.language}}>
      <StripeCheckoutForm
        paymentType={paymentIntent.type}
        email={email}
        paymentIntent={paymentIntent}
        onClose={onClose}
      />
    </Elements>
  );
};

export default Stripe;
